// EmojiPicker.tsx
import 'emoji-picker-element'
import { onCleanup } from 'solid-js'

declare module 'solid-js' {
	namespace JSX {
		interface IntrinsicElements {
			// biome-ignore lint/suspicious/noExplicitAny: <explanation>
			'emoji-picker': any
		}
	}
}

export const EmojiPicker = (props: { onSelect: (emoji: string) => void }) => {
	let pickerRef: HTMLElement

	const handleEmojiClick = (event: Event) => {
		const customEvent = event as CustomEvent
		props.onSelect(customEvent.detail.unicode)
	}

	// Attach event listener when component mounts
	onCleanup(() => {
		pickerRef?.removeEventListener('emoji-click', handleEmojiClick)
	})

	return (
		<div>
			<emoji-picker
				ref={(el: HTMLElement) => {
					pickerRef = el
					el.addEventListener('emoji-click', handleEmojiClick)
				}}
			/>
		</div>
	)
}
